import {MatchInfo, MatchInfoJson} from '/src/com/yext/listingslaunchstorm/js/data/matchinfo';

/**
 * @fileoverview Model representing the server response after requesting validation of store code
 * and fetching corresponding Google Match
 *
 * @author Sravan Parimi (sparimi@yext.com)
 */

export class ValidateStoreCodeResponse {
  /**
   * @param {{
   *  match: (!MatchInfo | undefined)
   * }} params
   */
  constructor(params) {
    /** @type {MatchInfo|undefined} */
    this.match = params.match;
  }

  /**
   * @param {ValidateStoreCodeResponseJson} json
   * @return {!ValidateStoreCodeResponse}
   */
  static fromJSON(json) {
    return new ValidateStoreCodeResponse({
      match: json['match'] && MatchInfo.fromJSON(json['match']),
    });
  }
}

/**
 * @dict
 * @typedef {{
 *  match: (!MatchInfoJson|undefined)
 * }}
 */
export var ValidateStoreCodeResponseJson;
